// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Company } from './company';
import { ContactPerson } from './contact-person';
import { Employee } from './employee';
import { User } from './user';

/**
 * 
 * @export
 * @interface PhysicalContractorNew
 */
export interface PhysicalContractorNew {
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    position?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    snils?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    postAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    education?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    educationSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    educationNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorNew
     */
    educationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    educationRegistrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    educationSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    educationInstitution?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    citizenship?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    middleName?: string;
    /**
     * 
     * @type {number}
     * @memberof PhysicalContractorNew
     */
    gender?: number;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorNew
     */
    birthday?: Date;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    passportSeries?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    passportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    passportIssuedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    whenPassportIssued?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    type?: string;
    /**
     * 
     * @type {User}
     * @memberof PhysicalContractorNew
     */
    user?: User;
    /**
     * 
     * @type {Company}
     * @memberof PhysicalContractorNew
     */
    company: Company;
    /**
     * 
     * @type {Employee}
     * @memberof PhysicalContractorNew
     */
    responsible?: Employee;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorNew
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PhysicalContractorNew
     */
    updatedAt?: Date;
    /**
     * 
     * @type {ContactPerson}
     * @memberof PhysicalContractorNew
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PhysicalContractorNew
     */
    studentIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof PhysicalContractorNew
     */
    objectType: PhysicalContractorNewObjectTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum PhysicalContractorNewObjectTypeEnum {
    PhysicalContractorNew = 'PhysicalContractorNew',
    JuridicalContractorNew = 'JuridicalContractorNew'
}



